import { render } from "./delete-group-modal.vue?vue&type=template&id=55e8c56a"
import script from "./delete-group-modal.vue?vue&type=script&lang=js"
export * from "./delete-group-modal.vue?vue&type=script&lang=js"
script.render = render

export default script